import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ApiService } from '../../../../src/services/apiService';



interface DropdownItem {
  key: number;
  value: string;
}

interface ListItem {
  key: string;
  value: string;
  isActive: boolean;
}

@Component({
  selector: 'app-committees',
  standalone: true,
  imports: [FormsModule, CommonModule, ProgressSpinnerModule],
  templateUrl: './committees.component.html',
  styleUrl: './committees.component.css'
})
export class CommitteesComponent implements OnInit {

  dropdownList: DropdownItem[] = [];
  selectedId: string = '';

  items: ListItem[] = [];
  loading = false;

  showConfirm = false;
  showAddDoctor = false;
  searchText: string = '';

  newDoctor = {
    committeeType: '',
    drName: '',
    jurisdiction: ''
  };

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.getDropdownData();
  }

  get filteredItems(): ListItem[] {
  if (!this.searchText) return this.items;

  const search = this.searchText.toLowerCase();

  return this.items.filter(item =>
    item.value.toLowerCase().includes(search) ||
    item.key.toLowerCase().includes(search)
  );
}

  // =========================
  // Dropdown API
  // =========================
  async getDropdownData() {
    this.loading = true;

    try {
      const req = this.apiService.getGetter(
        'HCDLookup/GetTypeOfDisabilites'
      );

      const res: any = await firstValueFrom(req);

      this.dropdownList = res.list || [];

    } catch (error) {
      console.error('Error in getDropdownData:', error);
    } finally {
      this.loading = false;
    }
  }

  // =========================
  // On dropdown change
  // =========================
  async onDropdownChange() {
    if (!this.selectedId) return;

    this.loading = true;

    try {
      const req = this.apiService.getGetter(
        `DiagnosticCommittees/GetDrNameByCommitteType?item=${encodeURIComponent(this.selectedId)}`
      );

      const res: any = await firstValueFrom(req);

      this.items = (res.list || []).map((item: any) => ({
        key: item.key,
        value: item.value,
        isActive: item.isActive
      }));

    } catch (error) {
      console.error('Error in onDropdownChange:', error);
    } finally {
      this.loading = false;
    }
  }

  // =========================
  // Update API
  // =========================
  async update() {
    const payload = {
      list: this.items.map(i => ({
        doctorId: i.key,
        isActive: i.isActive
      }))
    };

    console.log(payload);

    try {
      const req = this.apiService.postGetter(
        'DiagnosticCommittees/UpdateDoctorStatus',
        payload
      );

      const res: any = await firstValueFrom(req);

      if (res?.value) {
        alert('Updated successfully');
      } else {
        alert('Update failed');
      }

    } catch (error) {
      console.error('Error in update:', error);
    }
  }

  // =========================
  // UI Actions
  // =========================
  openConfirm() {
    this.showConfirm = true;
  }

  confirmUpdate() {
    this.showConfirm = false;
    this.update();
  }

  openAddDoctor() {
    this.showAddDoctor = true;
  }

  // =========================
  // Create Doctor API
  // =========================
  async createDoctor() {

    if (!this.newDoctor.committeeType || !this.newDoctor.drName || !this.newDoctor.jurisdiction) {
      alert('Please fill all fields');
      return;
    }

    const payload = {
      committeeType: Number(this.newDoctor.committeeType),
      drName: this.newDoctor.drName,
      jurisdiction: this.newDoctor.jurisdiction
    };

    try {
      const req = this.apiService.postGetter(
        'DiagnosticCommittees/CreateDoctor',
        payload
      );

      const res: any = await firstValueFrom(req);

      if (res?.value) {
        alert(res.message || 'Doctor created successfully');

        this.newDoctor = {
          committeeType: '',
          drName: '',
          jurisdiction: ''
        };

        this.showAddDoctor = false;

        if (this.selectedId) {
          this.onDropdownChange();
        }

      } else {
        alert(res.message || 'Failed to create doctor');
      }

    } catch (error) {
      console.error('Error in createDoctor:', error);
      alert('Something went wrong');
    }
  }
}